import { clsx, ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

import { ChatbotConfigSchema } from "./schema";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function createChatbotConfig(isStaff = false) {
  return ChatbotConfigSchema.parse({
    displayDisclosure: !!isStaff,
  });
}
